export default {
    downtimeUrl: "https://id2.kodland.tech",
    startPage: {
      image: "/welcome/quiz_base_1.jpg",
      title: "Ingin tau bagaimana Anak Anda dapat menghasilkan uang dengan bekerja di bidang teknologi?",
      subtitle:
        "Daftarkan anak Anda untuk pelajaran pemrograman GRATIS sekarang, dengan menyeledaikan survei",
      button: "Mulai  🚀",
    },
    successPage: {
      title: "Anda 1 langkah lagi dengan pembelajaran pemrograman GRATIS, dimana Anda akan tau lebih banyak tentang profesi bergaji tinggi yang cocok dan sempurna untuk anak Anda",
      subtitle: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀 Klik tombol “📆 Pesan” dan dapatkan pelajarannya",
      button: "📆 Pesan",
    },
    quizRotateBySteps: {
      1: {
        question: "Apa yang paling menggambarkan anak Anda?",
        answers: [
          "👾 Anak sering sekali bermain Game",
          "📱 Anak kecanduan dengan YouTube dan TikTok",
          "🧑‍💻 Anak memiliki ketertarikan pada pemrograman",
          "🚀 Saya ingin anak saya mendapatkan profesi yang berhubungan dengan ilmu komputer",
          "❓ Tidak ada satu pun",
        ],
      },
      2: {
        question: "Tingkat pengetahuan ilmu komputer apa yang dimiliki anak Anda saat ini?",
        answers: [
          "❤️ Pemula : Mereka tidak pernah mempelajari hal ini sebelumnya",
          "💛 Menengah : Terkadang mereka melihat / menonton tutorial tentang ini",
          "💚 Pro : Mereka mencoba pemrograman secara mandiri / otodidak",
        ],
      },
      3: {
        question: "Profesi seperti apa yang Anda yakini akan membuan anak Anda bahagia?",
        answers: [
          "🕹 Menyenangkan : Terhubung dengan industri Game",
          "⚡️ Kreatif : Membuat Website dan Applikasi",
          "🧑‍💻 Logis : Membuat sesuaty yang sulit dengan kode untuk perusahaan besar",
          "🤔 Saya masih tidak yakin, saya ingin tahu lebih jelas di pembelajaran gratis",
        ],
      },
    },
  };
  
  